import React, { useState } from "react";
import { TableUi } from "../components/table.ui";
import { BadgeCheckIcon, BanIcon, CheckCircleIcon, CheckIcon, EyeIcon, TrashIcon, XIcon } from "@heroicons/react/outline";
import { useMutation, useQuery } from "react-query";
import Constants from "../tools/constants.tools";
import commandeService from "../services/commande.service";
import { Modal } from "flowbite-react";
import { ButtonUi } from "../components/components";

export const Commande = () => {

  const [state, setState] = useState({
    showModal: false,
    cmdId: null,
    type:'servir', // rejeter
  })

  const _commandes = useQuery('commandes');
  const _rejetCmd = useMutation(commandeService.rejetCmd, {
    onSuccess: resp => {
      setState({...state, showModal: false, cmdId: null, type: 'servir'})
      _commandes.refetch()
    }
  })
  const _servieCmd = useMutation(commandeService.servieCmd, {
    onSuccess: resp => {
      setState({...state, showModal: false, cmdId: null, type: 'servir'})
      _commandes.refetch()
    }
  })
  const COLUMNS = [
    {
      Header: "##",
      accessor: "_id",
    },
    {
      Header: "Image",
      accessor: "image",
      Cell: ({ cell }) => (
        <div className="">
          <img
            className="w-14 h-14 rounded-full bg-gray-100"
            src={Constants.IMAGE_LINK+cell.row.values.image}
          />
        </div>
      ),
    },
    {
      Header: "Plat",
      accessor: "nom",
    },
    {
      Header: "Employé",
      accessor: "userId",
      Cell: ({ cell }) => (
        <div className="">
          {
            cell.row.values.userId.prenom.charAt(0).toUpperCase()+cell.row.values.userId.prenom.slice(1)+' '+ cell.row.values.userId.nom
          }
        </div>
      ),
    },

    {
      Header: "Prix",
      accessor: "prix",
      Cell: ({ cell }) => (
        <div className="bg-blue-500 p-1 rounded-full text-white">{cell.row.values.prix} GNF </div>
      ),
    },
    {
      Header: "Eau",
      accessor: "prixEau",
      Cell: ({ cell }) =>
        cell.row.values.prixEau !== 0 ? (
          <CheckIcon className="h-5 w-5 ml-5 text-white bg-green-400" />
        ) : (
          <BanIcon className="h-5 w-5 ml-5 bg-red-400 text-white" />
        ),
    },
    {
      Header: "Jus",
      accessor: "prixJus",
      Cell: ({ cell }) =>
        cell.row.values.prixJus !== 0 ? (
          <CheckIcon className="h-5 w-5 ml-5 text-white bg-green-400" />
        ) : (
          <BanIcon className="h-5 w-5 ml-5 bg-red-400 text-white" />
        ),
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) =>
      cell.row.values.status === 'attente' ? (
        <span className="bg-indigo-200 px-2 rounded-lg text-indigo-500 font-semibold p-1">
          préparation
        </span>
      ) : cell.row.values.status === "servie" ? (
        <span className="bg-green-200 px-2 rounded-lg text-green-500 font-semibold p-1">
          servie
        </span>
      ) : (
        <span className="bg-red-200 px-2 rounded-lg text-red-500 font-semibold p-1">
          rejetée
        </span>
      ),
    },
    {
      Header: "Action",
      Cell: ({ cell }) => {
        if(cell.row.values.status === 'attente'){
          return (
            <div className="flex gap-3 justify-center">
              <div className="rounded-md shadow-md p-1">
                <BadgeCheckIcon
                  className="cursor-pointer text-green-500 h-4 w-4"
                  onClick={() => {
                    setState({...state, type: 'servir', showModal: true, cmdId: cell.row.values._id})
                  }}
                />
              </div>
    
              <div className="rounded-md shadow-md p-1">
                <XIcon
                  className=" cursor-pointer text-red-500 h-4 w-4"
                  onClick={() => {
                    setState({...state, type: 'rejeter', showModal: true, cmdId: cell.row.values._id})
                  }}
                />
              </div>
            </div>
          )
        }
        return (
          <div className="flex gap-3 justify-center">
            <div className="rounded-md p-1 bg-gray-200">
              <BadgeCheckIcon
                className="cursor-pointer text-gray-500 h-4 w-4"
              />
            </div>
  
            <div className="rounded-md p-1 bg-gray-200">
              <XIcon
                className=" cursor-pointer text-gray-500 h-4 w-4"
              />
            </div>
          </div>
        )
        
      },
    },
  ];

  return (
    <div className="px-5 bg-white rounded-2xl">
      <div className="flex flex-col pt-2">
        <div className="flex flex-row text-center justify-between">
          <div className="flex flex-col text-left">
            <h1 className="text-xl ">Commandes</h1>
            <p className="text-gray-400 text-xs">Les commandes </p>
          </div>
        </div>

        <React.Fragment>
            <Modal
              show={state.showModal}
              size='sm'
              onClose={() => setState({...state, type: 'servir', showModal: false, cmdId: null})}>
              <Modal.Header>{
                state.type === 'servir' 
                  ? 'Servir la commande' 
                  : 'Rejeter la commande'
                }</Modal.Header>
              <Modal.Body className="space-y-6">
                <div className="text-gray-600 text-sm">
                  {
                    state.type === 'servir'
                      ? 'Si cette commande est prête pour servir, veillez cliquez sur Servir'
                      : 'Pour rejeter cette commande, veillez cliquez sur Rejeter'
                  }
                </div>
                <div>
                  {
                    state.type === 'servir'
                    ?  <ButtonUi 
                          isLoading={_servieCmd.isLoading}
                          onClick={() =>{
                            _servieCmd.mutate(state.cmdId)
                          }}
                        >Servir</ButtonUi>
                    :  <ButtonUi 
                          isLoading={_rejetCmd.isLoading}
                          onClick={() => _rejetCmd.mutate(state.cmdId)}
                          bColor='bg-red-600'
                        >Rejeter</ButtonUi>
                  }
                </div>
              </Modal.Body>
            </Modal>
          </React.Fragment>
      </div>
      {
        _commandes.isSuccess && _commandes.data?.data.length !== 0
          ? <TableUi columns={COLUMNS} data={_commandes.data?.data} colsHidden={["_id"]} />
          : <p className="text-gray-600 text-sm">Aucune commande trouvée</p>
      }

    </div>
  );
};
